import { Modal, Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styles from './DisableModal.module.less';
import { logout } from '@/utils';

interface PropsType {
  open?: boolean;
  teamName: string;
}
export const DisableModal = ({ open, teamName }: PropsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const handleLogout = () => {
    localStorage.removeItem('persist:root_develop');
    logout();
  };
  useEffect(() => {
    window.EVENT.on('DISABLE_MODAL_OPEN', () => {
      setIsModalOpen(true);
    });
    // window.EVENT.on('DISABLE_MODAL_CLOSE', () => {
    //   setIsModalOpen(false);
    // });
  }, []);
  return (
    <Modal
      title={''}
      open={isModalOpen || open}
      maskClosable={false}
      keyboard={false}
      closable={false}
      footer={null}
      centered={true}
    >
      <div>
        <div className={styles.modalTitle}>{t('develop_prefix_AccountDisabled')}</div>
        <div className={styles.modalContent}>
          <span style={{ color: '#ff8f00' }}>{teamName}&nbsp;</span>
          <Trans
            i18nKey={'develop_prefix_AccountDisabled2'}
            components={{
              a: <a style={{ color: '#4359F5 ' }} href="mailto:apps@dserspro.com"></a>,
            }}
          ></Trans>
        </div>
        <div className={styles.modalFoot}>
          <Button key="back" type="primary" onClick={handleLogout}>
            {t('develop_prefix_RejectPopupWindow3')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
